import React from 'react';

const OPERATOR_LABELS = {
  eq: '=', neq: '!=', gt: '>', gte: '>=', lt: '<', lte: '<=',
  like: 'contains', in: 'in', is_null: 'is empty', is_not_null: 'is not empty',
};

const OPERATORS_BY_TYPE = {
  string: ['eq', 'neq', 'like', 'is_null', 'is_not_null'],
  number: ['eq', 'neq', 'gt', 'gte', 'lt', 'lte', 'is_null', 'is_not_null'],
  date:   ['eq', 'neq', 'gt', 'gte', 'lt', 'lte', 'is_null', 'is_not_null'],
  enum:   ['eq', 'neq', 'in', 'is_null', 'is_not_null'],
};

export default function FilterBuilder({ columns, filters, onChange }) {
  const updateFilter = (idx, patch) => {
    const updated = [...filters];
    updated[idx] = { ...updated[idx], ...patch };
    onChange(updated);
  };

  const removeFilter = (idx) => {
    onChange(filters.filter((_, i) => i !== idx));
  };

  const addFilter = () => {
    onChange([...filters, { field: '', operator: '', value: '' }]);
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-2">
        <h3 className="text-xs font-semibold text-gray-600 uppercase tracking-wider">Filters</h3>
        <button
          onClick={addFilter}
          className="text-xs text-primary-600 hover:text-primary-700 font-medium"
        >
          + Add
        </button>
      </div>

      {filters.length === 0 && (
        <p className="text-xs text-gray-600 italic">No filters applied</p>
      )}

      <div className="space-y-1.5">
        {filters.map((f, idx) => {
          const col = columns.find(c => c.key === f.field);
          const ops = col ? (OPERATORS_BY_TYPE[col.type] || OPERATORS_BY_TYPE.string) : [];
          const needsValue = f.operator && !['is_null', 'is_not_null'].includes(f.operator);

          return (
            <div key={idx} className="flex items-center gap-1.5">
              <select
                value={f.field}
                onChange={e => updateFilter(idx, { field: e.target.value, operator: '', value: '' })}
                className="border border-gray-300 rounded text-xs px-1.5 py-1 min-w-0 flex-1 bg-white"
              >
                <option value="">Field...</option>
                {columns.filter(c => c.filterable !== false).map(c => (
                  <option key={c.key} value={c.key}>{c.label}</option>
                ))}
              </select>

              <select
                value={f.operator}
                onChange={e => updateFilter(idx, { operator: e.target.value })}
                className="border border-gray-300 rounded text-xs px-1.5 py-1 w-20 bg-white"
                disabled={!f.field}
              >
                <option value="">Op</option>
                {ops.map(op => (
                  <option key={op} value={op}>{OPERATOR_LABELS[op]}</option>
                ))}
              </select>

              {needsValue && (
                <input
                  type={col?.type === 'date' ? 'date' : col?.type === 'number' ? 'number' : 'text'}
                  value={f.value}
                  onChange={e => updateFilter(idx, { value: e.target.value })}
                  placeholder="Value..."
                  className="border border-gray-300 rounded text-xs px-1.5 py-1 min-w-0 flex-1"
                />
              )}

              <button
                onClick={() => removeFilter(idx)}
                className="text-gray-300 hover:text-red-500 p-0.5 flex-shrink-0"
              >
                <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
}
